// extracted by mini-css-extract-plugin
module.exports = {"shipping":"Shipping_shipping__Mex89"};